const buttons = [...document.querySelectorAll('.filter button')]
const items = [...document.querySelectorAll('[data-filter]')]

let active = '0'

const render = () => {
	buttons.forEach(button => button.classList.toggle('active', button.dataset.filter === active && active !== '0'))
	items.forEach(item => item.hidden = active !== '0' && item.dataset.filter !== '0' && item.dataset.filter !== active)
}

buttons.forEach(button => {
	button.addEventListener('click', () => {
		active = active === button.dataset.filter ? '0' : button.dataset.filter
		render()
	})
})

render()